function darkColor(section, key, { theme  }) {
    return theme(section, key.replace(/^([a-z]+)($|[.-])/, '$1Dark$2'));
}
export { darkColor as default };
//# sourceMappingURL=darkColor.js.map
